
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PdfAPI from '@/api/PdfAPI';
import { MeasurementPlanHistoryEntry } from '@/interfaces/components/MeasurementPlanHistoryEntry';

import moment from 'moment';
// @ts-ignore
import downloadFile from 'downloadjs';

@Component({ name: 'MeasurementPlanHistoryModal' })
export default class MeasurementPlanHistoryModal extends Vue {
    @Prop({ required: true }) private visible!: boolean;

    private entries: MeasurementPlanHistoryEntry[] = [];
    private isLoading = false;
    private downloadingId: number | null = null;

    @Watch('visible')
    private async onVisibleChange(val: boolean) {
        if (val) {
            await this.fetchHistory();
        }
    }

    public async refresh() {
        await this.fetchHistory();
    }

    private async fetchHistory() {
        this.isLoading = true;
        try {
            this.entries = await PdfAPI.getMeasurementPlanHistory();
        } catch {
            this.$notification.error({
                message: this.$t('Error') as string,
                description: this.$t('Could not load print history.') as string,
            });
        } finally {
            this.isLoading = false;
        }
    }

    private async handleRedownload(entry: MeasurementPlanHistoryEntry) {
        this.downloadingId = entry.id;
        try {
            const blob = await PdfAPI.redownloadMeasurementPlanPDF(entry.id);
            const formattedDate = moment(entry.printedAt).format('DD-MM-YYYY');
            downloadFile(blob, `Measurement_Plan_${formattedDate}.pdf`, 'application/pdf');
            this.$notification.success({
                message: this.$t('Success') as string,
                description: this.$t('PDF downloaded successfully.') as string,
            });
        } catch {
            this.$notification.error({
                message: this.$t('Error') as string,
                description: this.$t('Could not re-download this PDF.') as string,
            });
        } finally {
            this.downloadingId = null;
        }
    }

    private formatDate(iso: string): string {
        return moment(iso).format('DD.MM.YYYY HH:mm');
    }
}
